import { authStorage } from '@/lib/authStorage';
import ServiceAuthSSO from '@/services/ServiceAuthSSO';

// Papéis "analista" (visão interna Agnes) — quem enxerga a etapa da análise em vez
// do status simplificado do cliente. Paridade com o legado `StoreAuth.isPerfilAnalista`
// (authorities ∩ MENU_ROLES.ANALISTA_AGNES). Inclui os nomes novos (PT-BR) e os
// legados do ROLE_MIGRATION (§5) por tolerância durante a transição.
const PAPEIS_ANALISTA = new Set([
  'SUPER_ADMINISTRADOR',
  'ADMINISTRADOR',
  'ANALISTA',
  // fallbacks legados (Keycloak antigo)
  'ANALISTA_AGNES',
  'ADMIN',
  'ORG_ADMIN',
  'SUPER_ADMIN',
]);

/** Papéis do realm no JWT atual (vazio se não houver token). */
export function papeisAtuais(): string[] {
  const token = authStorage.getItem('access_Token');
  if (!token) return [];
  return ServiceAuthSSO.extractRolesFromToken(token) ?? [];
}

/**
 * true se o usuário tem perfil de analista (vê etapa/step); false = perfil de
 * cliente/usuário (vê status simplificado). Espelha o legado.
 */
export function isPerfilAnalista(): boolean {
  return papeisAtuais().some((r) => PAPEIS_ANALISTA.has(r));
}
